import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import '../Assets/Css/about.css';
import aboutbanner from '../Assets/Images/Aboutbanner.jpg';
import { FaMapMarkerAlt } from "react-icons/fa";
import { FaCogs, FaDraftingCompass, FaTools, FaPuzzlePiece } from "react-icons/fa";
import vision from '../Assets/Images/vision.png'
import mission from '../Assets/Images/mission.png'
// import aboutus from '../Assets/Images/About us image.png'


import client1 from '../Assets/Images/agio pharma logo.png'
import client2 from '../Assets/Images/ddenterprises_logo.jpg'
import client3 from '../Assets/Images/dinshaws.png'
import client4 from '../Assets/Images/emcure.png'
import client5 from '../Assets/Images/lupin logo.png'
import client6 from '../Assets/Images/mercedes logo.jpg'
import client7 from '../Assets/Images/poshs.jpg'
import client8 from '../Assets/Images/serum logo.png'

import { Helmet } from "react-helmet";



export default function About() {

  const clientLogos = [
    client1,client2,client3,client4,client5,client6,client7,client8
  ];

  return (
    <>
      <div className="mainnav">

      <Helmet>
        <title>
          About Us | AIM Industrial Products – Precision & Hygiene for Regulated Industries
        </title>

        <meta
          name="description"
          content="Learn about AIM Industrial Products – India’s trusted manufacturer of hygienic, precision mechanical components for the pharmaceutical, dairy, food, and automation sectors."
        />
        <meta
          name="keywords"
          content="About AIM Industrial Products, hygienic components, stainless steel parts, pharmaceutical industry, food processing equipment, CNC machining, PTFE parts, automation components"
        />
        <meta name="author" content="AIM Industrial Products" />
        <meta name="robots" content="index, follow" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="About AIM | Trusted for Performance, Driven by Precision"
        />
        <meta
          property="og:description"
          content="With decades of experience, AIM manufactures reliable, regulation-compliant components trusted by India's most demanding industries."
        />
        <meta
          property="og:image"
          content="https://yourdomain.com/assets/about-banner.jpg" // Replace with your About page image
        />
        <meta property="og:url" content="https://aimindproducts.com/about" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="About AIM Industrial Products | Manufacturing Trust with Precision"
        />
        <meta
          name="twitter:description"
          content="Explore AIM's vision, mission, and advanced manufacturing capabilities built to serve high-compliance industries with stainless steel and polymer components."
        />
        <meta
          name="twitter:image"
          content="https://yourdomain.com/assets/about-banner.jpg" // Replace this as needed
        />

        {/* Canonical URL */}
        <link rel="canonical" href="https://aimindproducts.com/about" />
      </Helmet>

        {/* Banner Section */}
        

<div className="about-banner position-relative text-white">
  <img
    src={aboutbanner}
    alt="About Banner"
    className="aboutbanner-image animate-banner-zoom"
  />
  <div className="maindesc position-absolute top-50 start-50 translate-middle  px-3">
    <h2 className="fw-bold ">
      Driven by Precision. Trusted for Performance.
    </h2>
    <p className="lead">
      Pioneering hygienic component solutions for India's most regulated industries.
    </p>
  </div>
</div>

        {/* Main Content */}
        <Container className="my-1">
          <Row className="mb-0">
            <Col>
              <Card className="border-0 p-3">
                <h2 className="Mainhead">Company Introduction</h2>
                <p className="fs-5 " style={{textAlign:'justify'}}>
                  <b>At AIM Industrial Products</b>, we specialize in the manufacturing and trading of precision mechanical components for high-hygiene industries such as <b>pharmaceuticals, dairy, and food </b> processing. With decades of hands-on industry experience, we understand the unique operational, hygiene, and compliance challenges our clients face. Our commitment is to deliver robust, reliable, and regulation-compliant solutions that drive performance and productivity across your operations.
                </p>
              </Card>
            </Col>
          </Row>
          </Container>

        
<div className="vision-mission-section">
<Row className="mb-4 m-0 justify-content-center">
  <Col md={10}>
    <Row className="m-0">
      {/* Vision */}
      <Col md={6} className="mb-3 ">
  <Card className="vissioncard border-0 p-4 h-100 text-center">
    <h2 className="Mainhead mb-4">Vision</h2>
    <img src={vision} alt="Vision" height={100} width={100} className="mb-3 mx-auto" />
    <p className='p-3' style={{ textAlign: 'justify' }}>
      To be India’s most trusted partner in precision-engineered stainless steel components,
      delivering performance, hygiene, and compliance to the pharmaceutical, food, dairy,
      and automation industries.
    </p>
  </Card>
</Col>


      {/* Mission */}
      <Col md={6} className="mb-3">
  <Card className="vissioncard border-0 p-4 h-100 text-center">
    <h2 className="Mainhead mb-4">Mission</h2>
    <img src={mission} alt="Mission" height={120} width={180} className="mb-3 mx-auto" />
    
    <ul className="mb-0 text-start" style={{ textAlign: 'justify', display: 'inline-block' }}>
      <li>
        To design, manufacture, and supply hygienic and high-performance stainless steel
        components that meet the stringent quality and compliance standards of regulated industries.
      </li>
      <li>
        To build lasting client partnerships through technical excellence, reliability, and responsive support.
      </li>
      <li>
        To drive continuous improvement through advanced manufacturing technologies and
        sustainable, future-ready practices.
      </li>
    </ul>
  </Card>
</Col>
    </Row>
  </Col>
</Row>
</div>

   <Container>
   <Row className="mb-3 py-0 m-0 justify-content-center">
      <Col lg={10}>
       
          <h2 className="Mainhead mb-4">Manufacturing Capabilities</h2>
          <p className="fs-6 " style={{textAlign:'justify'}}>
            Our state-of-the-art production facility is equipped to deliver standard and customized components tailored to your application.
            From small-batch runs to high-volume orders, we ensure tight tolerances, hygienic design, and material integrity across every product.
          </p>
          <div >
          <p className="subhead mt-4 mb-3">Capabilities include:</p>
          <ul className="custom-list ">
            <li><FaCogs className="me-2 icon" /> CNC Machining (Turning, Milling, Drilling)</li>
            <li><FaTools className="me-2 icon" /> Metal Fabrication (Stainless Steel – SS 304/316)</li>
            <li><FaPuzzlePiece className="me-2 icon" /> High-Performance Polymer Part Manufacturing (PTFE, PEEK, Nylon, Delrin)</li>
            <li><FaDraftingCompass className="me-2 icon" /> Surface Finishing (Polishing, Passivation, Electroplating)</li>
            <li><FaCogs className="me-2 icon" /> Assembly and Testing of Mechanical Subsystems</li>
            <li><FaTools className="me-2 icon" /> Custom Design Services with 3D CAD Support</li>
          </ul>
          </div>
      </Col>
    </Row>
   </Container>

<Row className="m-0 justify-content-center mb-4">
  <Col lg={10}>
    <div className="region-trust-section d-flex flex-column flex-md-row rounded overflow-hidden shadow-lg">
      <div className="region-trust-left p-4 p-md-5 d-flex flex-column justify-content-center text-white">
        <h2 className="display-6 fw-bold mb-3">Trusted by Clients Across Regions</h2>
        <p className="lead">what we provide and how we solve their problems</p>
        <p>
          Our reputation for delivering consistent quality and technical expertise has earned us the trust of clients across diverse markets.
        </p>
        <p>We proudly serve clients in:</p>
        <ul className="list-unstyled ms-3">
          <li><FaMapMarkerAlt className="me-2 text-warning" /> India</li>
        </ul>
        <p>
          Our global footprint is expanding, thanks to strong word-of-mouth, technical excellence, and dependable after-sales support.
        </p>
      </div>
      <div className="region-trust-right "></div>
    </div>
  </Col>
</Row>

<Container className="text-center py-4 org-section">
      <h2 className="Mainhead mb-4">Organizations We Serve</h2>
      <div className="logoclient-slider">
        <div className=" slideclient-track my-4">
          {clientLogos.concat(clientLogos).map((logo, index) => (
            <div className="slideclient" key={index}>
              <img src={logo} alt={`Client ${index + 1}`} className="client-logo" />
            </div>
          ))}
        </div>
      </div>
    </Container>
      </div>
    </>
  );
}
